export const generateList = (amount: number) => {
    return Array.from(Array(amount).keys());
}